import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import moment from "moment";
import AdminDiamondReportService from "../../services/reports-AdminDiamond-service";
import { Spin } from "antd";
import Chart from "react-google-charts";
import { chartColors } from "../reports/colors";

const AdminDiamondCutComp = ({
  globalDiamonds,
  mainForDealer,
  isApplyFilter,
  pageNo,
  pageSize,
  sortOrderCol,
  sortOrderType,
  setPageNo,
  handleGetDiamondCutList,
  setTableCutGradeValue,
  setPaginationPage,
  chartData,
  setColorData, 
  options,
  setChartData,
  colorData,
}) => {
  const { t } = useTranslation();

  const [dealerId, setDealerId] = useState();
  const loginDetials = useSelector((state) => state.loginReducer);
  const [DiamondCutSearchesLoading, setDiamondCutSearchesLoading] = useState(false);

  // Configuration
  const MAX_ENTRIES = 15; // Maximum entries to show

  

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleDiamondChartForCutGrade(
        loginDetials.loginDetials.responseData.dealerId,
        mainForDealer
      );
    }
  }, [isApplyFilter]);

  // Process chart data with max entries limit
  const processChartData = (responseData) => {
    if (!responseData?.length) {
      return { chartData: [], colors: [] };
    }

    // Filter out zero values and sort by count (descending)
    const filteredData = responseData.filter(item => item.CutGradeCount > 0);
    const sortedData = [...filteredData].sort((a, b) => b.CutGradeCount - a.CutGradeCount);

    // Apply max entries limit
    const topData = sortedData.slice(0, MAX_ENTRIES);
    const remainingData = sortedData.slice(MAX_ENTRIES);

    // Calculate "Others" if needed
    const othersValue = remainingData.reduce((sum, item) => sum + item.CutGradeCount, 0);
    if (othersValue > 0 && remainingData.length > 0) {
      topData.push({
        CutGrade: t("Others"),
        CutGradeCount: othersValue,
        isOthers: true
      });
    }

    // Prepare chart data
    const processedChartData = [
      ["Cut Grade", "Count", { role: "style" }, { role: "annotation" }],
    ];
    const colors = [];

    topData.forEach((item, index) => {
      const color = chartColors[index % chartColors.length];
      colors.push(color);

      processedChartData.push([
        item.CutGrade,
        item.CutGradeCount,
        color,
        item.CutGradeCount
      ]);
    });

    return { chartData: processedChartData, colors };
  };

  const handleDiamondChartForCutGrade = (dealerId, forDealer) => {
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        forDealer: forDealer ? forDealer.toString() : "",
        fromDate: globalDiamonds.dataRangeFrom
          ? moment(globalDiamonds.dataRangeFrom).format("YYYY-MM-DD")
          : "2020-08-17",
        toDate: globalDiamonds.dataRangeTo
          ? moment(globalDiamonds.dataRangeTo).format("YYYY-MM-DD")
          : "2022-09-15",
        retailerIds: globalDiamonds.retailerIds.toString(),
        vendorIds: globalDiamonds.vendorIds.toString(),
        selectedDiamondValue: globalDiamonds.SelectedDiamondValue,
      };
      setDiamondCutSearchesLoading(true);

      AdminDiamondReportService.DiamondChartForCutGrade(inputData)
        .then((response) => {
          setDiamondCutSearchesLoading(false);
          if (response.data.message === "Success" && response.data.responseData?.Table) {
            const responseData = response.data.responseData.Table;

            // Process data with max entries limit
            const { chartData: processedData, colors } = processChartData(responseData);
            setChartData(processedData);
            setColorData(colors);
          } else {
            setChartData([]);
            setColorData([]);
          }
        })
        .catch((error) => {
          setDiamondCutSearchesLoading(false);
          setChartData([]);
          setColorData([]);
        });
    } catch (error) {
      setDiamondCutSearchesLoading(false);
      setChartData([]);
      setColorData([]);
    }
  };

  const handleClick = ({ chartWrapper }) => {
    const chart = chartWrapper.getChart();
    const selection = chart.getSelection();
    if (selection.length > 0) {
      const selectedItem = selection[0];
      const label = chartData[selectedItem.row + 1][0];
      // Update parent state to trigger table refresh
      if (setTableCutGradeValue) {
        setTableCutGradeValue(label);
      }
      if (setPaginationPage) {
        setPaginationPage(1);
      }
    }
  };



  return (
    <React.Fragment>
      <div className="col-lg-12 mt-4">
        <label>
          <b>{t("Diamond Cut Searches")}</b>
        </label>

        <Spin spinning={DiamondCutSearchesLoading} size="large">
          {chartData.length > 1 ? (
            <>
              {/* Custom Legend */}
              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  marginBottom: "10px",
                }}
              >
                {chartData.slice(1).map((row, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      margin: "4px 8px",
                      fontSize: "13px",
                      fontWeight: "500",
                    }}
                  >
                    <div
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: colorData[index],
                        marginRight: "6px",
                        borderRadius: "3px",
                      }}
                    ></div>
                    {row[0]} ({row[1]})
                  </div>
                ))}
              </div>

              {/* Centered Bar Chart */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              >
                <Chart
                  chartType="ColumnChart"
                  data={chartData}
                  width={window.innerWidth > 500 ? "100%" : 300}
                  height={window.innerWidth > 500 ? 750 : 300}
                  options={options}
                  chartEvents={[
                    {
                      eventName: "select",
                      callback: handleClick,
                    },
                  ]}
                />
              </div>
            </>
          ) : (
            <div className="no-report-render">
              <div className="desc-space">
                <h4 className="text-center">{t("No Data Found")}</h4>
              </div>
            </div>
          )}
        </Spin>
      </div>
    </React.Fragment>
  );
};

export default AdminDiamondCutComp;